import GameAdmin from './GameAdmin';

export default GameAdmin;
